import React from "react";

export const CardClip = () => (
  <svg
    className="cardClip"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 0H0V15H0.0307419C0.546938 6.62927 7.4993 0 16 0Z"
    />
  </svg>
);
export const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke="#DFFAF1"
    width="36"
    height="35"
    viewBox="0 0 36 35"
    fill="none"
  >
    <path
      d="M18 28C23.799 28 28.5 23.299 28.5 17.5C28.5 11.701 23.799 7 18 7C12.201 7 7.5 11.701 7.5 17.5C7.5 23.299 12.201 28 18 28Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 23.3333V17.5"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 12.667H18.0136"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ChevronsRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <path
      d="M18.958 24.7913L26.2497 17.4997L18.958 10.208"
      stroke="#1E3C60"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.75 24.7913L16.0417 17.4997L8.75 10.208"
      stroke="#1E3C60"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
